export const slugify = (text = "") =>
    text
        .toString()
        .normalize("NFKD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

// The published date is a calendar date, not a moment in time. Read the date part as-is
// (no timezone conversion), otherwise midnight UTC shows up as the previous day in the US.
export const formatPublishedDate = (value) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value ?? ""));
    return m ? `${m[2]}/${m[3]}/${m[1]}` : "-";
};

// Links without a scheme (e.g. "google.com") would resolve relative to the blog page.
export const normalizeLinkUrl = (url) => {
    const v = String(url ?? "").trim();
    if (!v || /^(https?:\/\/|mailto:|tel:|\/|#)/i.test(v)) return v;
    return `https://${v}`;
};

export const todayStr = () => {
    const d = new Date();
    const p = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// data: { title, slug, kicker, description, body_html, author, tags[], status, published_at, file, remove_cover_image }
export const buildBlogFormData = (data, id) => {
    const fd = new FormData();
    if (id) fd.append("id", id);
    fd.append("title", data.title || "");
    fd.append("slug", data.slug || "");
    fd.append("kicker", data.kicker || "");
    fd.append("description", data.description || "");
    fd.append("body_html", data.body_html || "");
    fd.append("author", data.author || "");
    fd.append("tags", JSON.stringify(data.tags || []));
    fd.append("status", data.status || "draft");
    if (data.published_at) fd.append("published_at", data.published_at);
    if (data.file instanceof File) fd.append("file", data.file);
    if (data.remove_cover_image) fd.append("remove_cover_image", "true");
    return fd;
};
